import { NamedProperty } from "sprint-common-web/src/utils/types/NamedProperty";

import { AncillaryVersionDocumentResponse } from "../../../../common/api/catalogue-api/ancillary/AncillaryDocumentResponse";
import { MovieVersionDocumentResponse } from "../../../../common/api/catalogue-api/movie/MovieDocumentResponse";
import { EpisodeVersionResponse } from "../../../../common/api/catalogue-api/tv-api/TvSeriesResponse";

export interface MediaBuzzVersion {
    versionType: NamedProperty;
    distributor: string;
    brandings?: string;
    buzz?: {
        id: string;
        name?: string;
        notes?: string;
    };
}

export const mapToMediaBuzzVersion = (
    version: MovieVersionDocumentResponse | EpisodeVersionResponse
): MediaBuzzVersion => ({
    versionType: version.type,
    distributor: version.distributor.name,
    brandings: version.brandings?.map(getName).join(", "),
    buzz: version.buzzVersion
        ? {
              id: version.buzzVersion.id,
              name: version.buzzVersion.name,
              notes: version.buzzVersion.notes
          }
        : undefined
});

export const mapAncillaryToMediaBuzzVersion = (version: AncillaryVersionDocumentResponse): MediaBuzzVersion => ({
    versionType: version.type,
    distributor: version.distributor.name,
    brandings: version.airlines?.map(getName).join(", "),
    buzz: version.buzzId ? { id: version.buzzId } : undefined
});

const getName = (namedObject: { name: string }): string => namedObject.name;
